var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.214 13.4403L14.214 1.44033C13.734 0.960325 13.0673 0.666992 12.334 0.666992H3.00065C1.53398 0.666992 0.333984 1.86699 0.333984 3.33366V12.667C0.333984 13.4003 0.627318 14.067 1.12065 14.5603L13.1207 26.5603C13.6007 27.0403 14.2673 27.3337 15.0007 27.3337C15.734 27.3337 16.4006 27.0403 16.8806 26.547L26.214 17.2137C26.7073 16.7337 27.0006 16.067 27.0006 15.3337C27.0006 14.6003 26.694 13.9203 26.214 13.4403ZM5.00065 7.33366C3.89398 7.33366 3.00065 6.44033 3.00065 5.33366C3.00065 4.22699 3.89398 3.33366 5.00065 3.33366C6.10732 3.33366 7.00065 4.22699 7.00065 5.33366C7.00065 6.44033 6.10732 7.33366 5.00065 7.33366Z",
    fill: "#2E2B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.fe460630b388514873d25f8b7b86f71e.svg";
export { ForwardRef as ReactComponent };